var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "is-active": _vm.isOpen },
      attrs: { "data-component": "app-launcher-header-agent-info" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          _vm.isOpen = !_vm.isOpen
        },
      },
    },
    [
      _c("agent-avatar", { attrs: { avatar: _vm.avatar, person: _vm.agent } }),
      _vm._v(" "),
      _c("or-icon", { attrs: { icon: _vm.icon } }),
      _vm._v(" "),
      _vm.isOpen
        ? _c("agent-profile-popup", {
            attrs: {
              avatar: _vm.avatar,
              agent: _vm.agent,
              "app-version": _vm.appVersion,
              options: _vm.availableOptions,
            },
            on: {
              "option-click": _vm.onOptionClick,
              "sign-out": _vm.onSignOut,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }